export interface ServiceItem {
  icon: string;
  title: string;
  description: string;
  image?: string;
}


export const defaultServices: ServiceItem[] = [
  {
    icon: 'Sparkles',
    title: 'Creative Development',
    description: 'We transform ideas into impactful brand experiences through strategic storytelling, campaign planning, and innovative creative concepts. By combining market insights with compelling visuals and messaging, we develop campaigns that strengthen brand identity, engage audiences, and deliver measurable business outcomes across digital and traditional marketing channels.',
    image: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=800&q=80'
  },
  {
    icon: 'Smartphone',
    title: 'iOS & Android App Development',
    description: 'We build secure, scalable, and high-performance mobile applications for iOS and Android platforms. From UI/UX design and backend development to cloud integration and ongoing support, we deliver intuitive digital solutions that enhance customer experiences, streamline business operations, and drive long-term growth.',
    image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=800&q=80'
  },
  {
    icon: 'Globe',
    title: 'Website & Web App Development',
    description: 'We develop responsive websites and custom web applications that combine modern design with powerful functionality. Built for performance, security, and scalability, our solutions help businesses improve user engagement, optimize operations, and establish a strong digital presence across all devices.',
    image: 'https://images.unsplash.com/photo-1547658719-da2b51169166?auto=format&fit=crop&w=800&q=80'
  },
  {
    icon: 'Megaphone',
    title: 'Digital Advertising (Google, Meta, LinkedIn, YouTube)',
    description: 'Our data-driven advertising strategies maximize brand visibility and business growth through Google, Meta, LinkedIn, and YouTube campaigns. We optimize audience targeting, campaign performance, and conversion tracking to generate qualified leads, increase return on investment, and deliver measurable marketing success.',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=800&q=80'
  },
  {
    icon: 'Target',
    title: 'Content Marketing & SEO',
    description: 'We create high-quality, SEO-driven content that builds authority, improves search visibility, and attracts the right audience. Through strategic content planning, keyword optimization, and engaging storytelling, we help businesses generate organic traffic, strengthen brand credibility, and achieve sustainable digital growth.',
    image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?auto=format&fit=crop&w=800&q=80'
  },
  {
    icon: 'Award',
    title: 'Branding & Identity',
    description: 'We craft distinctive brand identities that reflect your vision, values, and market positioning. From logo design and visual identity systems to brand guidelines and packaging, we create consistent, memorable experiences that build trust, enhance recognition, and differentiate your business from competitors.',
    image: 'https://images.unsplash.com/photo-1561070791-26c113006238?auto=format&fit=crop&w=800&q=80'
  },
  {
    icon: 'Palette',
    title: 'Graphic Design',
    description: 'We design visually compelling marketing materials that communicate your brand with clarity and impact. From social media creatives and brochures to presentations, packaging, and promotional assets, our creative solutions strengthen brand consistency, capture attention, and support your business objectives across every platform.',
    image: 'https://images.unsplash.com/photo-1558655146-d09347e92766?auto=format&fit=crop&w=800&q=80'
  },
];

export interface PortfolioItem {
  title: string;
  category: string;
  description: string;
  image: string;
  tags?: string;
}

export const defaultPortfolio: PortfolioItem[] = [
  {
    title: 'Lovixo Dating App',
    category: 'MOBILE APPLICATION / DATING',
    description: 'A modern dating platform with glassmorphism UI, floating animated elements, and interactive matchmaking cards.',
    image: '/biggrow/uploads/lovixo_dating_app.png',
    tags: 'Flutter, Dart, PHP'
  },
  {
    title: 'Krida Esports - Online Tournament Platform',
    category: 'GAMING / ESPORTS',
    description: 'An esports tournament hub featuring real-time leaderboards, tournament scheduling, and player profiles.',
    image: '/biggrow/uploads/krida_esports_app.png',
    tags: 'Java/Kotlin, Android SDK, PHP'
  },
  {
    title: 'Aura Cosmetics E-Commerce',
    category: 'RETAIL / E-COMMERCE',
    description: 'A premium minimalist online beauty store featuring immersive product displays and tailored virtual experience elements.',
    image: '/biggrow/uploads/aura_cosmetics_shop.png',
    tags: 'Next.js, Tailwind CSS, Shopify API'
  },
  {
    title: 'Apex Analytics SaaS Dashboard',
    category: 'TECHNOLOGY / FINTECH',
    description: 'A real-time financial tracking SaaS offering advanced AI-driven predictive insights, interactive chart sets, and custom reports.',
    image: '/biggrow/uploads/apex_analytics_dashboard.png',
    tags: 'React, TypeScript, Go, Tailwind CSS'
  }
];

export interface TestimonialItem {
  quote: string;
  author: string;
  role: string;
  company: string;
  image: string;
}

export const defaultTestimonials: TestimonialItem[] = [
  {
    quote: 'BigGroww transformed our brand presence with creative campaigns and innovative solutions. Their team is professional, responsive, and results-driven.',
    author: 'Suthar Jagdish',
    role: 'Client',
    company: '',
    image: '',
  },
  {
    quote: 'Working with BigGroww elevated our digital strategy. They understood our vision and delivered measurable growth.',
    author: 'Patel Shivani',
    role: 'Client',
    company: '',
    image: '',
  },
  {
    quote: 'From concept to execution, BigGroww exceeded expectations. Their creativity and attention to detail are unmatched.',
    author: 'Gadhvi Devang',
    role: 'Client',
    company: '',
    image: '',
  },
  {
    quote: 'BigGroww combines creativity with strategy, helping our business grow and engage customers effectively.',
    author: 'Baman Dilip',
    role: 'Client',
    company: '',
    image: '',
  },
  {
    quote: 'Working with BigGroww felt effortless; their team understood our vision, executed flawlessly, and delivered beyond measurable results in record time.',
    author: 'Daniel Johnson',
    role: 'Client',
    company: '',
    image: '',
  },
  {
    quote: 'Our sales skyrocketed after partnering with BigGroww; their innovative campaigns helped us connect authentically with new audiences everywhere.',
    author: 'Julia Michele',
    role: 'Client',
    company: '',
    image: '',
  },
  {
    quote: 'BigGroww transformed our online presence with creative strategies, measurable results, and consistent growth that exceeded expectations every single month.',
    author: 'Robert Green',
    role: 'Client',
    company: '',
    image: '',
  },
  {
    quote: 'Thanks to BigGroww, our brand gained visibility, leads converted into customers, and digital growth became achievable, measurable, and sustainable.',
    author: 'Oliver Goodman',
    role: 'Client',
    company: '',
    image: '',
  },
];

export interface AboutData {
  image: string;
}

export const defaultAbout: AboutData = {
  image: ''
};

// Migrate localStorage data to version 2 (new structure)
const CURRENT_VERSION = '2';
if (typeof window !== 'undefined') {
  try {
    if (localStorage.getItem('biggrow_data_version') !== CURRENT_VERSION) {
      localStorage.removeItem('services');
      localStorage.removeItem('portfolio');
      localStorage.removeItem('testimonials');
      localStorage.removeItem('about');
      localStorage.setItem('biggrow_data_version', CURRENT_VERSION);
    }
  } catch (e) {
    console.error('Failed to migrate localStorage:', e);
  }
}

export const getData = <T,>(key: string, defaultData: T): T => {
  const data = localStorage.getItem(key);
  if (data) {
    return JSON.parse(data) as T;
  }
  localStorage.setItem(key, JSON.stringify(defaultData));
  return defaultData;
};

export const saveData = <T,>(key: string, data: T): void => {
  localStorage.setItem(key, JSON.stringify(data));
};
